import React, { useState } from 'react';
import { Tabs, Tab, Box, Button, Grid, Collapse } from '@mui/material';
import AssignmentForm from './AssignmentForm';
import AssignmentList from './AssignmentList';
import { Helmet } from 'react-helmet-async';

function ManageAssignmentsByIssuer() {
  const [tabIndex, setTabIndex] = useState(0);
  const [showMoreDetails, setShowMoreDetails] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box>
      <Helmet>
        <title>Manage Assignments</title>
      </Helmet>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        textColor="primary"
        indicatorColor="primary"
        sx={{ ml: 4 }}
        TabIndicatorProps={{ sx: { width: 'auto' } }}
      >
        <Tab label="Manage Assignment" sx={{ minWidth: "auto", px: 2 }} />
        <Tab label="Create Assignment" sx={{ minWidth: "auto", px: 2 }} />
      </Tabs>

      <TabPanel value={tabIndex} index={0}>
        <AssignmentList />
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <AssignmentForm showMoreDetails={showMoreDetails} setShowMoreDetails={setShowMoreDetails} />
      </TabPanel>
    </Box>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default ManageAssignmentsByIssuer;
